/*
 * @Author: g05047
 * @Date: 2021-03-09 11:29:55
 * @LastEditors: g05047
 * @LastEditTime: 2021-03-12 16:26:46
 * @Description: file content
 */
import fvSubassembly from '../fvSubassembly';
export default class fvRect extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        //创建图元
        //添加折线
        this.buttonColorInit = "rgba(255,255,255,0)";
        this.system = system;
        this.buttonG=document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.buttonDom = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
        this.buttonTextDom = document.createElementNS('http://www.w3.org/2000/svg', 'text')
        this.system.appendChild(this.buttonG);
        this.buttonG.appendChild(this.buttonDom);
        this.createSucss(this.buttonG, sContent);
        this.buttonG.appendChild(this.buttonTextDom);
        // this.buttonG.insertBefore((this.buttonDom, this.buttonTextDom);
        this.buttonDef = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        
        let str =`<filter id="${this.registerName}" x="0" y="0" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="3"/>
        <feOffset dx="2" dy="2" />
        <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
        </feMerge>
    </filter>`;

        // let str = `<linearGradient id="${this.registerName}" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1">
        // </linearGradient>`;
        this.buttonDef.innerHTML = str;
        this.buttonG.insertBefore(this.buttonDef, this.buttonDom);
        if(this.renderType==4||this.renderType==5||this.renderType==6){
            this.buttonDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            system.insertBefore(this.buttonDefs, this.buttonG);
        }
        //创建样式
        this.parent = parent;
        this.g=document.createElementNS('http://www.w3.org/2000/svg', 'g')
        this.sContent=sContent;
        this.createStyle();
    }
    createStyle() {
        this.setPosition();
        this.setFillColor();
        this.rotateRect();
        // this.buttonTextDom.setAttribute('alignment-baseline', "middle");
        this.buttonDom.style.width = this.width + "px";
        this.buttonDom.style.height = this.height + "px";
        this.buttonG.style.width = this.width + "px";
        this.buttonG.style.height = this.height + "px";
        this.buttonDom.style.cursor="pointer";
        // this.buttonDom.style.strokeWidth = this.borderWidth
        // this.buttonDom.style.stroke = this.borderColor
        let r=".2em";
        this.buttonDom.setAttribute('rx',r)
        this.buttonDom.setAttribute('ry',r)
        this.buttonTextDom.style.lineHeight = this.height + 'px';
        this.buttonTextDom.style.textAlign = this.align;
        let font = this.setFontSize(this.font);
        this.buttonTextDom.style.font = this.font;
        this.buttonTextDom.style.fontSize = font;
        this.buttonTextDom.style.fill = this.color;
        this.buttonTextDom.style.backgroundColor = this.clarity ? "rgba(0,0,0,0)" : this.borderColor;
        this.buttonTextDom.style.textDecoration = this.underline ? 'underline' : 'none';
        this.setText();
        //线型
        super.chooseRenderType(this.lineType, this.buttonDom)
        // this.isRound()
        this.Render();

        //风格，移动等预制动画
        // console.log(this.renderType)
    }
    rotateRect(){
        var px = parseFloat(this.cx - this.parent.parentX);
        var py = parseFloat(this.cy - this.parent.parentY);

        var cx = parseFloat(px + (this.width / 2));
        var cy = parseFloat(py + (this.height / 2));
        //旋转// 旋转度数 * Math.PI/180
        this.buttonDom.setAttribute("transform",`translate(${cx},${cy})rotate(180)translate(${-cx},${-cy})`)
    }
    // 	通过添加一个 span 到 body 容器中得到字体的实际宽度和高度后
	// 然后删除 span 标签
    chkstrlen(str)
　　{
　　　　var strlen = 0;
　　　　for(var i = 0;i < str.length; i++)
　　　　{
　　　　　　if(str.charCodeAt(i) > 255) //如果是汉字，则字符串长度加2
　　　　　　　　strlen += 2;
　　　　　　else  
　　　　　　　　strlen++;
　　　　}
　　　　return   strlen;
　　}
	computeFontSize(str, size, family) {
		let spanDom = document.createElement("span");
		spanDom.style.fontSize = size;
		spanDom.style.opacity = "0";
		spanDom.style.fontFamily = family;
		spanDom.innerHTML = str;
		document.body.append(spanDom);
		let sizeD = {};
		sizeD.width = spanDom.offsetWidth;
		sizeD.height = spanDom.offsetHeight;
		spanDom.remove();
		return sizeD;
	}
    setPosition() {
        this.buttonDom.setAttribute('x', this.cx - this.parent.parentX);
        this.buttonDom.setAttribute('y', this.cy - this.parent.parentY);
    }
    setFillColor() {
        this.isHollow()
    }
    // 设置字体缩放
	setFontSize(font) {
		var tempFont = font;
		this.worldSize = parseInt(tempFont.match(/\d{0,}px/g).toString().replace("px", ""));
		this.worldSize = this.worldSize == 0 ? 15 : this.worldSize;
        this.worldSize = parseFloat(this.worldSize * this.magnification.x);
		this.fontSize = PtToPx(this.worldSize);
		return this.fontSize-1+ "px";

	}
    //文本内容
    setText(){
        let arr = this.font.split(" ");
		arr  = arr.splice(arr.length-1,arr.length);
		var info=this.computeFontSize(this.innerText,this.buttonTextDom.style.fontSize,arr[0]);
        this.innerText=this.innerText.replace(/ /g,'&nbsp;');
        this.buttonText = this.innerText.toString().split("");
        let x, y;
        this.width=parseFloat(this.buttonDom.style.width);
        this.height=parseFloat(this.buttonDom.style.height);
        let font = this.setFontSize(this.font);
        let sizeInfo=this.chkstrlen(this.innerText);
        if (this.verticalDisplay) {
            if (this.align == "right") {
				x = this.width + (this.cx - this.parent.parentX) - parseFloat(this.buttonTextDom.style.fontSize);
			} else if (this.align == "center") {
				 x = this.width / 2 + (this.cx - this.parent.parentX) - (parseFloat(this.buttonTextDom.style.fontSize) / 2);
			} else {
				x = (this.cx - this.parent.parentX);
			}
            // x = this.width / 2 + (this.cx - this.parent.parentX) - (parseFloat(this.buttonTextDom.style.fontSize) / 2);
            y = (this.cy - this.parent.parentY) + parseFloat(this.buttonTextDom.style.fontSize);
            var innerHtml = '';
            for (var i = 0; i < this.buttonText.length; i++) {
                if (i * parseFloat(this.buttonTextDom.style.fontSize) > this.height) {
					break;
				}else{
                    let size = this.setFontSize(this.font);
                    innerHtml += `<text x="${x}" y=${y + (i * parseFloat(this.buttonTextDom.style.fontSize))} style="font:${this.font};fill:${this.color};font-size:${size};text-decoration:${this.underline ? 'underline' : 'none'}">${this.buttonText[i]}</text>`
                } 
            }
            this.g.innerHTML = innerHtml;
            this.buttonG.insertBefore(this.g, this.buttonDom.nextSibling);
            this.g.style.cursor="pointer";

        } else {
            if (this.align == "right") {
				x = this.width + (this.cx - this.parent.parentX);
                this.buttonTextDom.style.textAnchor="end";
			} else if (this.align == "center") {
				x = this.width/2+ (this.cx - this.parent.parentX);
                this.buttonTextDom.style.textAnchor="middle";
			} else {
				x = (this.cx - this.parent.parentX);
			}
            y = this.height/2 + (this.cy - this.parent.parentY)+(parseFloat(this.buttonTextDom.style.fontSize) / 2);
            this.buttonTextDom.innerHTML = this.innerText;
            this.buttonTextDom.style.writingMode = "none";
            this.buttonTextDom.style.cursor="pointer";
        }
       
       
        this.buttonTextDom.setAttribute('x', x);
        this.buttonTextDom.setAttribute('y', y);
    }
     // 显示隐藏
     isShow(value) {
        value ? this.buttonG.style.display = 'block' : this.buttonG.style.display = 'none';
    }
    init() {
        super.init();
        if (this.originalSize.width / (this.frameScaleX + 1) >= 2) {
            this.width -= 1;
        }
        this.moveWidth = this.borderWidth / 2;
        //如位置不对重新计算位置
    }
    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.buttonG);
        this.buttonG.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.buttonG.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }
    //风格渲染
    Render() {
        if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
        let x = this.buttonDom.getAttribute("x");
        let y = this.buttonDom.getAttribute("y");
        switch (this.renderType) {
            // case 1:  //模式1
            // case 2:  //模式2
            // case 3:  //模式3
            case 4:  //svg线性渐变效果
                this.linearGradient(this.registerName, this.renderConfig, this.buttonG,x,y,this.buttonDefs);
                break;
            case 5:  //svg路径渐变效果
                this.radialGradient(this.registerName, this.renderConfig, this.buttonG, x, y,this.buttonDefs);
                break;
            case 6:  //svg纹理渐变效果

                this.pattern(this.registerName, this.buttonG,this.buttonDefs);
                break;
            default:
                break;
        }
    }
    // 是否有圆角
    // isRound() {
    //     if (this.round) {
    //         this.buttonDom.setAttribute('rx', this.round[0])
    //         this.buttonDom.setAttribute('ry', this.round[1])
    //     } else {
    //         this.buttonDom.removeAttribute('rx')
    //         this.buttonDom.removeAttribute('ry')
    //     }
    // }
    //是否是空心
    isHollow() {
            // this.borderColor = this.borderColor.colorRgb(this.opacity / 255);
            // let str=` <stop offset="0" stop-color="${this.buttonColorInit}" fill-opacity="0">
            // </stop><stop offset="0.017" stop-color="${this.borderColor}" fill-opacity="1">
            // </stop><stop offset="1" stop-color="${this.borderColor}" fill-opacity="1">
            // </stop>`
            this.buttonDom.style.fill=this.borderColor;
            this.buttonDom.style.stroke="rgba(255,255,255,.9)";
            this.buttonDom.style.strokeWidth=2;
        //    document.getElementById(this.registerName).innerHTML=str;
        //    this.buttonDom.style.fill = `url(#${this.registerName})`;
           this.buttonDom.setAttribute("filter",`url(#${this.registerName}`)
    }
    /*16进制颜色转为RGBA格式*/
    hexToRgba(hex, opacity) {
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")";
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvButtonObj.js